import { TGender } from '@components/Cacl/types'

export enum Tabs {
  capital = 'capital',
  payment = 'payment',
}

export type TTabs = {
  [key in Tabs]: string
}

export interface IValues {
  gender: TGender
  age: number
  monthlyPayment: number
  period: number // years
}

export interface ISResultItemProps {
  title: string
  value: string | number
}

export interface IContributionsProps {
  title: string
  resultsData: ISResultItemProps[]
}

export interface IControlProps extends IValues {
  setGender: (gender: TGender) => void
  setAge: (age: number) => void
  setMonthlyPayment: (monthlyPayment: number) => void
  setPeriod: (period: number) => void
}

export interface IWithHidden {
  hidden?: boolean
}
